//https://developer.spotify.com/documentation/web-playback-sdk/quick-start/#

export const authEndpoint = "https://accounts.spotify.com/authorize"; //redirects to spotify login page
const redirectUri = "http://localhost:3000/";   // redirect to hoem page once logged in
const clientId = "c999a5ba62b949e594763f7db971b417"

const scopes = [
  "user-read-current-playing",
  "user-read-recently-played",
  "user-read-playback-state",
  "user-top-read",
  "user-modify-playback-state",
];

export const getTokenFromUrl = () =>{
  return window.location.hash
      .substring(1)
      .split('&')
      .reduce((initial,item) =>{
        var parts = item.split("=") ;
        initial[parts[0]] = decodeURIComponent(parts[1]);
      return initial;

      }, {} );
}

export const loginUrl = `${authEndpoint}?client_id=${clientId}&redirect_uri=${redirectUri}&scopes=${scopes.join(
  "%20"
)}&response_type=token&show_dialog=true`;